import React from 'react';

import type { FormFieldProps } from './forms.types';

const FormField: React.FC<FormFieldProps> = ({
  label,
  error,
  helpText,
  required = false,
  children,
  className = '',
  htmlFor,
}) => {
  return (
    <div className={`space-y-1 ${className}`}>
      {label && (
        <label
          htmlFor={htmlFor}
          className="block text-label-sm font-medium text-neutral-300"
        >
          {label}
          {required && <span className="text-primary-400 ml-1">*</span>}
        </label>
      )}

      <div>{children}</div>

      {error && <p className="text-label-sm text-error-400">{error}</p>}

      {helpText && !error && (
        <p className="text-label-xs text-neutral-400">{helpText}</p>
      )}
    </div>
  );
};

export default FormField;
